import Pricestar from "@/assets/svgs/Pricestar";

export type FeatureHighlightBarPropType = {
  titles: string[];
};

const marqueeAnimation = `
@keyframes marquee {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
}
`;

const FeatureHighlightBar = ({ titles }: FeatureHighlightBarPropType) => {
  // Duplicate the titles for seamless looping
  const marqueeTitles = [...titles, ...titles];
  return (
    <div className="w-full flex justify-center bg-transparent relative">
      <style>{marqueeAnimation}</style>
      <div
        className="flex items-center overflow-x-hidden bg-[#8984FF] py-2 h-[64px] gap-5 w-full"
      >
        <div
          className="flex items-center gap-5 animate-marquee whitespace-nowrap"
          style={{
            animation: 'marquee 18s linear infinite',
            minWidth: '200%',
          }}
        >
          {marqueeTitles.map((title, idx) => (
            <>
              <span
                key={title + idx}
                className="font-inter font-normal text-[24px] leading-[32px] text-white align-middle flex items-center tracking-[-0.5px]"
              >
                {title}
              </span>
              {idx < marqueeTitles.length - 1 && (
                <span className="mx-2 flex items-center" key={`star-${idx}`}
                >
                  <Pricestar />
                </span>
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureHighlightBar;